export class ItemFilterModel {
  codeItem: string = "";
  codeIntItem: number = 0;
  nameItem: string = "";
  wildcard: string | null = null;
  wildcard2: string | null = null;
  valueItem: number | null = null;
  valueDecimalItem: number = 0;
  valueLongItem: number | null = null;
  valueBoolItem: boolean = false;
  valueStringItem: string = "";

  constructor(nameItem: string, valueItem: number | null, valueLongItem: number | null, valueStringItem: string) {
    this.nameItem = nameItem;
    this.valueItem = valueItem;
    this.valueLongItem = valueLongItem;
    this.valueStringItem = valueStringItem;
  }
}
